export { ProductModel } from './product.model'
